/**  Arrow SVG imported:
 *   https://img.icons8.com/?size=100&id=39792&format=png&color=FFFFFF  **/

/***************/
/**  IMPORTS  **/
/***************/

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/

/****************************/
/**  LOCAL/ASSETS IMPORTS  **/
/****************************/
import PdfLocation from "./PdfLocation";
import PdfLocation1 from "./PdfLocation1";
import Park from "./Park";

import {
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";

/******************/
/**  PDF STYLES  **/
/******************/
const styles = StyleSheet.create({
    block: {
        flexDirection: "row",
        display: "flex",
        justifyContent: "center",
        marginLeft: -300,
        width: "300px",
    },
    column: {
        flexDirection: "column",
        display: "flex",
        justifyContent: "space-around",
        color:"black",
        width: "400px",
        padding: "2 0 4 0",
    },
    columnRight: {
        flexDirection: "column",
        display: "flex",
        justifyContent: "space-around",
        color:"black",
        width: "400px",
        padding: "2 0 4 0",
    },
    });

const StreetBlockPDF = ({ addresses, street, between, parks, building, divisor, maxTotalAddresses, flipped, highlightAvailableIsChecked, highlightTempClosedIsChecked }) => {

    let theStreet = street;
    if(!street){
        theStreet = "UNION";
    }
    
    // Helper function to remove duplicates based on building number
    const removeDuplicates = (addressArray) => {
        const seenBuildingNumbers = new Set();
        return addressArray?.filter((addressObj) => {
            const buildingNumber = parseInt(addressObj.address.split(" ")[0], 10);
            if (seenBuildingNumbers.has(buildingNumber)) {
                return false; // Skip duplicates
            }
            seenBuildingNumbers.add(buildingNumber);
            return true;
        });
    };
    // Remove duplicates from evens and odds
    const uniqueEvens = removeDuplicates(addresses?.evens);
    const uniqueOdds = removeDuplicates(addresses?.odds);

   // Set constants
    const horizontalStreetHeight = 3;
    const totalPageHeight = 741;
    const availableHeight = totalPageHeight - (divisor * horizontalStreetHeight);

    // Get padded lengths
    const evensLength = addresses?.evens?.length ?? 0;
    const oddsLength = addresses?.odds?.length ?? 0;
    const totalAddressesEvens = Math.max(3, evensLength);
    const totalAddressesOdds = Math.max(3, oddsLength);

    // Get the greater of the two for the current block
    const currentMax = Math.max(totalAddressesEvens, totalAddressesOdds);

    // Calculate the block height relative to the most dense street
    const maxHeight = (availableHeight / maxTotalAddresses) * currentMax;

    const beforePark = {};
    const afterPark = {};
    let oddsLeftOvers = 0;
    let evensLeftOvers = 0;

    if(parks) {
        for (const [key, value] of Object.entries(parks)) {
            const tokens = key.split(" ");
            const firstToken = tokens[0];
            
            if (firstToken.toLowerCase() === "before") {
                const newKey = tokens.slice(1).join(" ");
                beforePark[newKey] = value;
            } else if (firstToken.toLowerCase() === "after") {
                const newKey = tokens.slice(1).join(" ");
                afterPark[newKey] = value;
            } else {
                if (Number(firstToken) % 2 === 0 && key === building){
                    evensLeftOvers++;
                } else if (Number(firstToken) % 2 !== 0 && key === (Number(building) + 1).toString()){
                    oddsLeftOvers++;
                }
            }
        }
    }

    function countInSameHundreds(parks, building) {
        const buildingNum = parseInt(building, 10);
        const baseHundreds = Math.floor(buildingNum / 100) * 100;
      
        let evenCount = 0;
        let oddCount = 0;
      
        for (const key in parks) {
          const tokens = key.split(" ");
          const lastToken = tokens[tokens.length - 1];
          const num = parseInt(lastToken, 10);
      
          if (!isNaN(num) && num >= baseHundreds && num < baseHundreds + 100) {
            if (num % 2 === 0) {
              evenCount++;
            } else {
              oddCount++;
            }
          }
        }
      
        return { even: evenCount, odd: oddCount };
    }

    const parkPerBlockEvens = countInSameHundreds(parks, building).even;
    const parkPerBlockOdds = countInSameHundreds(parks, building).odd;

    const addressesEvens = evensLength * 7 + 20;
    const remainingHeightEvens = ((maxHeight - addressesEvens) / parkPerBlockEvens) - 5;

    const addressesOdds = oddsLength * 7 + 20;
    const remainingHeightOdds = ((maxHeight - addressesOdds) / parkPerBlockOdds) - 5;

    // const finalHeight = Math.max(maxHeight + remainingHeightEvens, maxHeight + remainingHeightOdds);
    
    return (
        <View style={[styles.block]}>
            {flipped ? (
                <>
                    {/* LeftBlock: Odds */}
                    <View style={[styles.column, { alignItems: "flex-end" }]}>
                        {oddsLeftOvers > 0 && remainingHeightOdds > 0 && (
                            <View style={{ flexDirection: 'row', display: 'flex' }}>
                                <Park 
                                    park={parks[(Number(building) + 1).toString()]}
                                    number={"even"}
                                    fillHeight={remainingHeightOdds}
                                    flipped={flipped} />
                            </View>
                        )}
                        {uniqueOdds?.map((addressObj, index) => {
                            const buildingNumber = addressObj.address.split(" ")[0]; // Get building number
                            const horizontalStreetText = between?.[buildingNumber];
                            const beforeParkBar = beforePark?.[buildingNumber];
                            const afterParkBar = afterPark?.[buildingNumber];

                            return (
                                <>
                                    {beforeParkBar && remainingHeightOdds > 0 && (
                                        <Park 
                                            park={beforePark[buildingNumber]}
                                            number={"even"}
                                            fillHeight={remainingHeightOdds}
                                            flipped={flipped} />
                                    )}
                                    <PdfLocation key={index} data={{address: addressObj.address}} addresses={addresses} flipped={flipped} highlightAvailableIsChecked={highlightAvailableIsChecked}  highlightTempClosedIsChecked={highlightTempClosedIsChecked} />
                                    {horizontalStreetText && ( // Only render HorizontalStreet if a match is found
                                    <View style={{display: "flex", flexDirection: "row", marginRight: "-5px"}}>
                                        <Text style={{color:"#205DBC", display: "flex", flexDirection: "column", fontSize: "4px", marginTop: "-1px", marginLeft: "-2px", paddingRight: "2px"}}>{horizontalStreetText}</Text>
                                        <View style={{display: "flex", flexDirection: "column", backgroundColor: "#205DBC",height: "3px", justifyContent: "center", width: "100px"}} />
                                    </View>
                                    )}
                                    {afterParkBar && remainingHeightOdds > 0 && (
                                        <Park 
                                            park={afterPark[buildingNumber]}
                                            number={"even"}
                                            fillHeight={remainingHeightOdds}
                                            flipped={flipped} />
                                    )}
                                </>
                            );
                        })}
                    </View>

                    {/* VerticalStreet */}
                    <View style={{flexDirection:"column", display:"flex", width:"15px", height:`${maxHeight}px`, marginTop: "-2px"}}>
                        <View style={{width: '100%', backgroundColor: '#205DBC', display: "flex", alignItems: "center", justifyContent: "center", height:"100%"}}>
                            {maxHeight > 20 && (
                                <View>
                                    <Text style={{color: "white", fontSize: "4px", fontStyle: 'bold', width: '50px', transform: 'rotate(90)', textAlign: 'center'}}>{theStreet.toUpperCase()}</Text>
                                </View>
                            )}
                        </View>
                    </View>

                    {/* RightBlock: Evens */}
                    <View style={styles.columnRight}>
                        {evensLeftOvers > 0 && remainingHeightEvens > 0 && (
                            <View style={{ flexDirection: 'row', display: 'flex' }}>
                                <Park 
                                    park={parks[(Number(building) + 1).toString()]}
                                    number={"odd"}
                                    fillHeight={remainingHeightEvens}
                                    flipped={flipped} />
                            </View>
                        )}
                        {uniqueEvens?.map((addressObj, index) => {
                            const buildingNumber = addressObj.address.split(" ")[0]; // Get building number
                            const horizontalStreetText = between?.[buildingNumber];
                            const beforeParkBar = beforePark?.[buildingNumber];
                            const afterParkBar = afterPark?.[buildingNumber];

                            return (
                                <>
                                    {beforeParkBar && remainingHeightEvens > 0 && (
                                        <Park 
                                        park={beforePark[buildingNumber]}
                                        number={"odd"}
                                        fillHeight={remainingHeightEvens}
                                        flipped={flipped} />
                                    )}
                                    <PdfLocation1 key={index} data={{address: addressObj.address}} addresses={addresses} flipped={flipped} highlightAvailableIsChecked={highlightAvailableIsChecked} highlightTempClosedIsChecked={highlightTempClosedIsChecked} />
                                    {horizontalStreetText && ( // Only render HorizontalStreet if a match is found
                                    <View style={{display: "flex", flexDirection: "row", }}>
                                        <View style={{display: "flex", flexDirection: "column", backgroundColor: "#205DBC", height: "3px", justifyContent: "center", width: "100px"}} />
                                        <Text style={{color:"#205DBC", display: "flex", flexDirection: "column", fontSize: "4px", marginTop: "-1px", marginRight: "-2px", paddingLeft: "2px"}}>{horizontalStreetText}</Text>
                                    </View>
                                    )}
                                    {afterParkBar && remainingHeightEvens > 0 && (
                                        <Park 
                                        park={afterPark[buildingNumber]}
                                        number={"odd"}
                                        fillHeight={remainingHeightEvens}
                                        flipped={flipped} />
                                    )}
                                </>
                            );
                        })}
                    </View>
                </>
            ) : (
                <>
                    {/* LeftBlock: Evens */}
                    <View style={[styles.column, { alignItems: "flex-end" }]}>
                        {evensLeftOvers > 0 && remainingHeightEvens > 0 && (
                            <View style={{ flexDirection: 'row', display: 'flex' }}>
                                <Park 
                                    park={parks[building]}
                                    number={"even"}
                                    fillHeight={remainingHeightEvens} />
                            </View>
                        )}
                        {uniqueEvens?.map((addressObj, index) => {
                            const buildingNumber = addressObj.address.split(" ")[0]; // Get building number
                            const horizontalStreetText = between?.[buildingNumber];
                            const beforeParkBar = beforePark?.[buildingNumber];
                            const afterParkBar = afterPark?.[buildingNumber];

                            return (
                                <>
                                    {beforeParkBar && remainingHeightEvens > 0 && (
                                        <Park 
                                            park={beforePark[buildingNumber]}
                                            number={"even"}
                                            fillHeight={remainingHeightEvens} />
                                    )}
                                    <PdfLocation key={index} data={{address: addressObj.address}} addresses={addresses} highlightAvailableIsChecked={highlightAvailableIsChecked} highlightTempClosedIsChecked={highlightTempClosedIsChecked}/>
                                    {horizontalStreetText && ( // Only render HorizontalStreet if a match is found
                                    <View style={{display: "flex", flexDirection: "row", marginRight: "-5px"}}>
                                        <Text style={{color:"#205DBC", display: "flex", flexDirection: "column", fontSize: "4px", marginTop: "-1px", marginLeft: "-2px", paddingRight: "2px"}}>{horizontalStreetText}</Text>
                                        <View style={{display: "flex", flexDirection: "column", backgroundColor: "#205DBC",height: "3px", justifyContent: "center", width: "100px"}} />
                                    </View>
                                    )}
                                    {afterParkBar && remainingHeightEvens > 0 && (
                                        <Park 
                                            park={afterPark[buildingNumber]}
                                            number={"even"}
                                            fillHeight={remainingHeightEvens} />
                                    )}
                                </>
                            );
                        })}
                    </View>

                    {/* VerticalStreet */}
                    <View style={{flexDirection:"column", display:"flex", width:"15px", height:`${maxHeight}px`, marginTop: "-2px"}}>
                        <View style={{width: '100%', backgroundColor: '#205DBC', display: "flex", alignItems: "center", justifyContent: "center", height:"100%"}}>
                            {maxHeight > 20 && (
                                <View>
                                    <Text style={{color: "white", fontSize: "4px", fontStyle: 'bold', width: '50px', transform: 'rotate(90)', textAlign: 'center'}}>{theStreet.toUpperCase()}</Text>
                                </View>
                            )}
                        </View>
                    </View>

                    {/* RightBlock: Odds */}
                    <View style={styles.columnRight}>
                        {oddsLeftOvers > 0 && remainingHeightOdds > 0 && (
                            <View style={{ flexDirection: 'row', display: 'flex' }}>
                                <Park 
                                    park={parks[(Number(building) + 1).toString()]}
                                    number={"odd"}
                                    fillHeight={remainingHeightOdds} />
                            </View>
                        )}
                        {uniqueOdds?.map((addressObj, index) => {
                            const buildingNumber = addressObj.address.split(" ")[0]; // Get building number
                            const horizontalStreetText = between?.[buildingNumber];
                            const beforeParkBar = beforePark?.[buildingNumber];
                            const afterParkBar = afterPark?.[buildingNumber];

                            return (
                                <>
                                    {beforeParkBar && remainingHeightOdds > 0 && (
                                        <Park 
                                        park={beforePark[buildingNumber]}
                                        number={"odd"}
                                        fillHeight={remainingHeightOdds} />
                                    )}
                                    <PdfLocation1 key={index} data={{address: addressObj.address}} addresses={addresses} highlightAvailableIsChecked={highlightAvailableIsChecked} highlightTempClosedIsChecked={highlightTempClosedIsChecked}/>
                                    {horizontalStreetText && ( // Only render HorizontalStreet if a match is found
                                    <View style={{display: "flex", flexDirection: "row", }}>
                                        <View style={{display: "flex", flexDirection: "column", backgroundColor: "#205DBC", height: "3px", justifyContent: "center", width: "100px"}} />
                                        <Text style={{color:"#205DBC", display: "flex", flexDirection: "column", fontSize: "4px", marginTop: "-1px", marginRight: "-2px", paddingLeft: "2px"}}>{horizontalStreetText}</Text>
                                    </View>
                                    )}
                                    {afterParkBar && remainingHeightOdds > 0 && (
                                        <Park 
                                        park={afterPark[buildingNumber]}
                                        number={"odd"}
                                        fillHeight={remainingHeightOdds} />
                                    )}
                                </>
                            );
                        })}
                    </View>
                </>
            )}
            
        </View>
    );
};

export default StreetBlockPDF;